import { IconButton, IconChevronLeftRegular, IconChevronRightRegular } from '@telefonica/mistica';
import BulletPoints from '../BulletPoints';
import './index.scss';

interface BillsPageBulletsType {
    debt: boolean;
    charSlide: number;
    bulletPointsClickHandler: (index: number) => void;
    numPages: number;
    arrowHandler: (value: boolean) => void;
}

const BillsPageBullets = ({
    debt,
    charSlide,
    bulletPointsClickHandler,
    numPages,
    arrowHandler,
}: BillsPageBulletsType) => {
    return (
        <div className='bills-bullet-page' style={{ marginBottom: !debt ? '16px' : '0px' }}>
            <div className='bills-bullet-page__svg' onClick={() => arrowHandler(true)}>
                <IconButton small Icon={IconChevronLeftRegular} aria-label='Previous slide' />
            </div>

            <BulletPoints numPoints={numPages} activeIndex={charSlide} onClick={bulletPointsClickHandler} />

            <div className='bills-bullet-page__svg' onClick={() => arrowHandler(false)}>
                <IconButton small Icon={IconChevronRightRegular} aria-label='Next slide' />
            </div>
        </div>
    );
};

export default BillsPageBullets;
